var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-dialog",
    {
      staticClass: "page-dialog center-dialog",
      attrs: {
        title: _vm.dialogTitle,
        visible: _vm.visible,
        width: "600px",
        "close-on-click-modal": false,
      },
      on: { close: _setup.handleClose },
    },
    [
      _c(
        "div",
        { staticClass: "dialog-content" },
        [
          _c(
            "el-form",
            {
              ref: "formRef",
              attrs: {
                model: _setup.localFormData,
                rules: _setup.formRules,
                "label-width": "80px",
                size: "small",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "分类名称", prop: "type_name" } },
                [
                  _c(_setup.LanguageInput, {
                    staticStyle: { width: "420px" },
                    attrs: {
                      lang: _setup.localFormData.type_name_lang,
                      placeholder: "请输入分类名称",
                      maxlength: 50,
                      "show-word-limit": true,
                      clearable: "",
                    },
                    on: {
                      "update:lang": function ($event) {
                        return _vm.$set(
                          _setup.localFormData,
                          "type_name_lang",
                          $event
                        )
                      },
                    },
                    model: {
                      value: _setup.localFormData.type_name,
                      callback: function ($$v) {
                        _vm.$set(_setup.localFormData, "type_name", $$v)
                      },
                      expression: "localFormData.type_name",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "排序", prop: "sort" } },
                [
                  _c("el-input-number", {
                    staticClass: "sort-input",
                    attrs: { min: 0, max: 9999, "controls-position": "right" },
                    model: {
                      value: _setup.localFormData.sort,
                      callback: function ($$v) {
                        _vm.$set(_setup.localFormData, "sort", $$v)
                      },
                      expression: "localFormData.sort",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "图标", prop: "icon_url" } },
                [
                  _c(_setup.SingleImageUpload, {
                    attrs: { size: 100 },
                    model: {
                      value: _setup.localFormData.icon_url,
                      callback: function ($$v) {
                        _vm.$set(_setup.localFormData, "icon_url", $$v)
                      },
                      expression: "localFormData.icon_url",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _setup.handleClose } }, [
            _vm._v("取消"),
          ]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _setup.loading },
              on: { click: _setup.handleConfirm },
            },
            [_vm._v("确认")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }